import { render } from "./FilesUploaded.vue?vue&type=template&id=2649e84c"
import script from "./FilesUploaded.vue?vue&type=script&lang=js"
export * from "./FilesUploaded.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__